module.exports = {"edit":"Edit Provider Chain","type":"Provider Chain Type","spec":"Provider Chain","resetHint":"Click icon to reset to default"}